export class User {
  id: string;
  name: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  get fullName(): string {
    return `${this.name} ${this.lastName}`;
  }
}
